import { LoginResponse } from 'framework/api/models/auth-models';

export const validatePostLogin = (loginDTO: any): LoginResponse => {
    return {
        token: loginDTO.token || '',
        permissions: loginDTO.permissions || []
    };
};
